import { useEffect } from 'react';

import { useWizard } from '/src/hooks';
import { CodeBox } from '/src/components/CodeBox';
import { VideoPlayer } from '/src/components/VideoPlayer';
import { useScriptUrl } from '/src/features/installation/utils';
import { WizardHeader, WizardSubHeader, WizardList, LightBulbIcon } from '/src/components/wizard/legacy/wizard-ui';

import { SupportLinks } from '/src/support';

import WordpressPoster from '../assets/wordpress-instructions-poster.jpg';
import WordpressVideo from '../assets/wordpress-instructions.mp4';

export function WordPressInstructions() {
  const [code] = useScriptUrl();
  const { set: wizardSet } = useWizard();

  useEffect(() => {
    wizardSet({
      back: '/install/choose-method',
      backEnabled: true,
      next: '/install/wordpress/check-script',
      nextEnabled: true,
      title: 'Integrate Crazy Egg with WordPress',
      currentStep: 2,
      totalSteps: 3,
    });
  }, [wizardSet]);

  return (
    <div className="text-body-2 flex flex-col">
      <WizardHeader className="!mb-5">Alright, let&#39;s use WordPress!</WizardHeader>
      <WizardSubHeader>Follow the instructions below for a completely code-free install.</WizardSubHeader>

      <div className="text-header-4 mb-2.5">Instructions:</div>
      <WizardList>
        <WizardList.Item>Log into your WordPress account.</WizardList.Item>
        <WizardList.Item>
          Click on <strong className="text-body-1">Plugins</strong> along the left-hand side.
        </WizardList.Item>
        <WizardList.Item>
          Click on <strong className="text-body-1">Add New</strong> in the submenu.
        </WizardList.Item>
        <WizardList.Item>
          At the top right hand corner, type in <strong className="text-body-1">Crazy Egg</strong> within the{' '}
          <strong className="text-body-1">Search plugins…</strong> input field.
        </WizardList.Item>
        <WizardList.Item>
          Find the Crazy Egg plugin. Click on <strong className="text-body-1">Install Now</strong> and{' '}
          <strong className="text-body-1">Activate</strong>.
        </WizardList.Item>
        <WizardList.Item>
          Click on <strong className="text-body-1">Settings</strong> under the Crazy Egg Plugin. Or, click on the Crazy
          Egg tab along the left-hand side.
        </WizardList.Item>
        <WizardList.Item>
          Copy and paste the Crazy Egg tracking script below into the{' '}
          <strong className="text-body-1">Your Tracking Script</strong> input field.
        </WizardList.Item>
        <WizardList.Item>
          Click on <strong className="text-body-1">Save Changes</strong>.
        </WizardList.Item>
      </WizardList>

      <div className="my-5 rounded bg-white-lilac-500 px-6 py-5">
        <strong className="text-body-1">Note:</strong> If you are using a cache plugin on your site, you will need to
        clear it after you have installed your Crazy Egg code.
      </div>

      <CodeBox loading={false} code={code} />

      <div className="mb-2.5 mt-5 flex items-center">
        <LightBulbIcon />
        Need a hand? Watch this video to see these steps in action:
      </div>

      <div className="border border-mystic-500">
        <VideoPlayer src={WordpressVideo} poster={WordpressPoster} label="WordPress installation video" />
      </div>

      <a href={SupportLinks.install.wordpress} className="text-link mt-2.5" target="_blank" rel="noreferrer">
        Learn more about integrating Crazy Egg with WordPress
      </a>

      <div className="mt-5">
        Click on <strong className="text-body-1">Next</strong> once you have integrated Crazy Egg with WordPress.
      </div>
    </div>
  );
}
